define(function(require, exports, module) {
    'use strict';

    module.exports = {
        notify: function(options) {
            window.Playtech.API.popup.showPopup('confirmation', {
                layer: 'HIGH_PRIORITY',
                closeAll: true,
                isModal: true,
                className: 'terms-popup',
                title: 'playtech.mobile.system.popup.TC.title',
                content: '<div class="content"><iframe src="' + options?.data?.tcVersionUrl + '"></iframe></div>',
                acceptBtnText: 'playtech.mobile.system.message.accept',
                declineBtnText: 'playtech.mobile.system.message.decline',
                ...options.data
            });
        }
    };
});
